/*global Clipboard:true*/

var module = angular.module('sdCompanyProfileModule');
/**
 * Directive that handles the sticky nav bar for the Service Professional profile pages
 */
module.directive('sdShare', ["$parse", "$compile", "$timeout", function ($parse, $compile, $timeout) {
    return {
        scope: {
            labelShare: '@',
            labelCopied: '@',
            text: '=',
            success: '&',
            link: '@'
        },
        restrict: 'A',
        templateUrl: '/account/tpl/share-button.html',
        replace: true,
        link: function (scope, element) {
            scope.link = scope.link || false;
            new Clipboard(element[0], {
                text: function() {
                    scope.$apply(function(){
                        scope.copied = true;
                        $timeout(function(){
                            scope.copied = false;
                        }, 5000);
                        if (typeof scope.success !== 'undefined') {
                            scope.success();
                        }
                    });
                    return scope.text;
                }
            });
        }
    };
}]);
